import { Route, RouteObject } from 'react-router-dom';
import { MxDashboard } from './components';
import Dashboard from './components/validationDashboard/Dashboard';
import UnifiedDashboard from './components/UnifiedDashboard';


export interface mxDashboardRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxDashboardRoute[];
}

export const mxDashboardRoutes: mxDashboardRoute[] = [
  {
      path: 'mx/dashboard',
      element: <UnifiedDashboard />,
    },
];
